// src/pages/facilities/TaskSetupRedirect.jsx
//
// R5 B4 (rule 6) — the old Templates and Schedules routes
// (`/tasks/templates`, `/tasks/schedules`) REDIRECT to Tasks → Setup with
// their section anchored (`/tasks/setup#templates`, `#schedules`), every
// query parameter riding along — no 404, a bookmark lands on the section
// it always meant. `replace`, so Back does not bounce the keeper into the
// redirect again (FeedingTabRedirect's precedent). Its own small file so
// App.js can import it eagerly without pulling Setup out of its chunk.
import React from 'react';
import PropTypes from 'prop-types';
import { Navigate, useLocation, useParams } from 'react-router-dom';

export const setupHref = (facilityId, section, search = '') => (
  `/facilities/${facilityId}/tasks/setup${search || ''}${section ? `#${section}` : ''}`
);

export default function TaskSetupRedirect({ section }) {
  const { facilityId } = useParams();
  const { search } = useLocation();
  return <Navigate to={setupHref(facilityId, section, search)} replace />;
}

TaskSetupRedirect.propTypes = {
  section: PropTypes.oneOf(['templates', 'schedules']).isRequired,
};
